<template>
    <section class="confirmation">
        <img :src="backgroundImage"
            class="image"
        >

        <div class="content">
            <div v-if="confirmation.referenece"
                class="content__id"
            >
                #{{ confirmation.reference }}
            </div>

            <div class="content__title">{{ confirmation.title }}</div>

            <div v-if="confirmation.body"
                class="content__amount"
            >
                {{ confirmation.body }}
                <span v-if="confirmation.icon === 'success'">{{ amount }}</span>
            </div>
        </div>

        <div v-if="confirmation.acceptButton"
            class="buttons"
        >
            <div class="buttons__button buttons__button--success"
                @click="buttonActions(confirmation.acceptButton.action)"
            >
                {{ confirmation.acceptButton.text }}
            </div>

            <div v-if="confirmation.cancelButton"
                class="buttons__button"
                @click="buttonActions(confirmation.cancelButton.action)"
            >
                {{ confirmation.cancelButton.text }}
            </div>
        </div>
    </section>
</template>

<script>
// 3rd party
import {
    mapActions,
    mapGetters,
} from 'vuex';

// Utils
import {
    formatNumber,
} from '@shared/utils/formatter.js';

// Local Types
import localEpicTypes from '@webapp/store/types.js';

export default {
    name: 'payment-confirmation',
    computed: {
        ...mapGetters(['modal']),

        backgroundImage() {
            return this.confirmation.icon ? require(`@webapp/assets/statuses/${this.confirmation.icon}.webp`) : '';
        },

        confirmation() {
            return Object.keys(this.modal.data).length
                ? this.modal.data.confirmation
                : {};
        },

        amount() {
            return Object.keys(this.modal.data).length
                ? this.modal.data.amount
                : '';
        },
    },
    mounted() {
        this.setModal({
            isVisible() {
                window.scrollTo({
                    top: 0,
                });
            },
        });
    },
    methods: {
        ...mapActions({
            resetModal: localEpicTypes.RESET_MODAL,
            setModal: localEpicTypes.SET_MODAL,
        }),

        getFormattedNumber(number) {
            return formatNumber(number);
        },

        buttonActions(action) {
            if (action === 'goToWallet') {
                this.$router.push('/wallet');
            }
            this.resetModal();
        },
    },
};
</script>

<style lang="scss" scoped>
.confirmation {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.content {
    padding-top: 6.6rem;
    background: $white-color;
    text-align: center;
    color: $cyprus-color;

    @include max-width(sm) {
        padding-top: 2.6rem;
    }

    &__id {
        color: $daintree-color;
        font-size: 1.1rem;
        line-height: 2.2rem;
        opacity: 0.65;
        padding-bottom: 1.2rem;
        font-weight: bold;
    }

    &__title {
        font-size: 2.2rem;
        font-weight: 700;
        line-height: 3.4rem;
        padding-bottom: 2.2rem;

        @include min-width(md) {
            font-size: 2.5rem;
        }

        @include max-width(sm) {
            font-size: 2rem;
        }
    }

    &__amount {
        font-size: 1.5rem;
        line-height: 2rem;
        padding-bottom: 5rem;
        white-space: pre-line;

        @include max-width(sm) {
            font-size: 1.2rem;
            padding-bottom: 2.5rem;
        }

        span {
            display: block;
            font-weight: 700;
        }
    }
}

.image {
    display: block;
    margin: 0 auto;
    object-fit: contain;
    max-width: 13.6rem;
    min-height: 12rem;

    @include min-width(md) {
        max-width: 15.6rem;
        min-height: 16rem;
    }

    @include max-width(sm) {
        max-width: 9.6rem;
        min-height: 11rem;
    }
}

.buttons {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: auto;

    &__button {
        cursor: pointer;
        text-align: center;
        color: $cyprus-color;
        width: 34rem;
        margin: 2rem 0 0;
        font-size: 1.5rem;

        &:hover {
            opacity: 0.8;
        }

        @include max-width(sm) {
            width: 25rem;
        }

        &--success {
            line-height: 4rem;
            border-radius: 0.4rem;
            color: $daintree-color;
            background: $lima-color;
        }
    }
}
</style>